/**
 * Single display formatter for a horse's breed(s): "Arabian" or
 * "Arabian / Warmblood" when a second breed is recorded (mixed-breed
 * patients). Every breed display site goes through this — never read
 * horse.breed directly for display, or the second breed silently drops.
 *
 * Trims and filters falsy/empty values: the sync push path doesn't apply the
 * REST ''→null normalization for secondBreed, so an offline-edited row can
 * hold '' and must not render as "Arabian / ".
 */
export function formatBreed(
  horse?: { breed?: string | null; secondBreed?: string | null } | null,
): string {
  if (!horse) return '';
  return [horse.breed, horse.secondBreed]
    .map((b) => (b ?? '').trim())
    .filter(Boolean)
    .join(' / ');
}
